export default __webpack_public_path__ + "static/media/art-hauntington.fcb7c1e2.jpg";